// ***NOTE*** Please preserve alphabetical order when adding new icons
export {
  faBatteryQuarter,
  faCalendarAlt,
  faCommentCheck,
  faFileChartLine,
  faFileSpreadsheet,
  faFilter,
  faHandPaper,
  faHomeLg,
  faHouseSignal,
  faLink,
  faSignal,
  faSignalAltSlash,
  faSignalStream,
  faSirenOn,
  faTrafficCone,
  faTimesSquare,
  faUnlink,
  faWifiSlash as faWifiSlashSolid,
} from '@fortawesome/pro-solid-svg-icons'
